import { useFieldArray, UseFormReturn } from "react-hook-form";
import TextEditor from "../../Global/Editors/TextEditor";
import NumberEditor from "../../Global/Editors/NumberEditor";
import { DTOModule } from "../../../types/building";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { nameof } from "../../Global/Utils";
import { IModuleVattenburetSekundärsystemRound, Värmekurva } from "../../../types/ModuleDatas";
import CheckboxEditor from "../../Global/Editors/CheckboxEditor";
import { MapTooltip } from "../../../types/globalData";
import { Button, Card, Table } from "react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRemove, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Colors } from "../../../modules/Colors";
import BFLNote from "../BFL/BFLNote";

interface IProps {
  module: IModuleRound;
  data: any;
  formHook: UseFormReturn;
}

const RoundVarmeSekundar = ({ module, data, formHook }: IProps) => {
  const pumpstoppSaknas = formHook.watch("pumpstoppSaknas");
  const isSummer = useRound().getActiveRound()?.isSummer;

  const { append, remove } = useFieldArray({
    control: formHook.control,
    name: "värmekurva",
  });

  const värmekurva = formHook.watch("värmekurva");

  return (
    <>
      <div className="row ml-0 align-items-end">
        <div className="col-lg-9">
          <TextEditor
            isDisabled={true}
            showWhenIsDisabled={true}
            label="Betjäningsområde"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("betjäningsområde")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_betjäningsområde")}
            formHook={formHook}
          />
        </div>
        <div className="col-lg-3">
          <NumberEditor
            isDisabled={true}
            showWhenIsDisabled={true}
            label="Värmens systemandel (%)"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("värmeSystemandel")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_värmeSystemandel")}
            formHook={formHook}
          />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12">
          <NumberEditor
            isDisabled={true}
            showWhenIsDisabled={true}
            label="Cirkulationspumpens EL effekt (W)"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("elEffekt")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_elEffekt")}
            formHook={formHook}
          />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12">
          <NumberEditor
            label="Börvärde framledning °C (Från värmekurva)"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("framledningBorvarde")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_framledningBorvarde")}
            formHook={formHook}
            options={{
              required: "Måste fyllas i",
              min: { value: 0, message: "Värde ska vara högre än 0" },
              max: { value: 100, message: "Värde ska vara 100 eller mindre" },
              valueAsNumber: true,
            }}
          />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12">
          <NumberEditor
            label="Ärvärde framledning °C"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("framledningArvarde")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_framledningArvarde")}
            formHook={formHook}
            options={{
              required: "Måste fyllas i",
              min: { value: 0, message: "Värde ska vara högre än 0" },
              max: { value: 100, message: "Värde ska vara 100 eller mindre" },
              valueAsNumber: true,
            }}
          />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12">
          <NumberEditor
            label="Ärvärde returledning °C"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("returledningArvarde")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_returledningArvarde")}
            formHook={formHook}
            options={{
              required: "Måste fyllas i",
              min: { value: 0, message: "Värde ska vara högre än 0" },
              max: { value: 100, message: "Värde ska vara 100 eller mindre" },
              valueAsNumber: true,
            }}
          />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12">
          <NumberEditor
            label="Temperatur utegivare °C"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("utegivareTemperatur")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_utegivareTemperatur")}
            formHook={formHook}
            options={{
              required: "Måste fyllas i",
              min: { value: 0, message: "Värde ska vara högre än 0" },
              max: { value: 100, message: "Värde ska vara 100 eller mindre" },
              valueAsNumber: true,
            }}
          />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12">
          <NumberEditor
            label="Utstyrning värmeventil (%) "
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("varmeventilUtstyrning")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_varmeventilUtstyrning")}
            formHook={formHook}
            // formatOptions={{ suffix: " %" }}
            options={{
              validate: {
                required: (v) => {
                  return v === undefined || v === null ? "Värde måste anges för utstyrning värmeventil" : undefined;
                },
              },
            }}
          />
        </div>
      </div>

      <div className="row ml-0 d-flex align-items-center">
        <div className="col-lg-6 ">
          <NumberEditor
            label="Inställning pumpstopp °C"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("pumpstoppInstallning")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_pumpstoppInstallning")}
            formHook={formHook}
            isDisabled={pumpstoppSaknas}
            options={{
              required: "Måste fyllas i",
              min: { value: 0, message: "Värde ska vara högre än 0" },
              max: { value: 100, message: "Värde ska vara 100 eller mindre" },
              valueAsNumber: true,
            }}
          />
          {/* {!pumpstoppSaknas && (
          )} */}
        </div>

        <div className="col-lg-6 mt-3">
          <CheckboxEditor
            label="Pumpstopp saknas"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("pumpstoppSaknas")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_pumpstoppSaknas")}
            formHook={formHook}
          />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12 mb-3">
          <SelectEditor
            items={["PUMP I DRIFT", "PUMP EJ I DRIFT"]}
            label="Funktionskontroll pumpstopp °C"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("pumpstoppKontroll")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_pumpstoppKontroll")}
            formHook={formHook}
          />
        </div>
      </div>

      {/* <Card>
        <Card.Header>Brytpunkter</Card.Header>
        <Table borderless>
          <thead>
            <tr>
              <th></th>
              <th>Brytpunkt utetemp (°C)</th>
              <th>Brytpunkt framledningstemp (°C)</th>
            </tr>
          </thead>
          <tbody>
            {värmekurva.map((kurva: any, i: number) => (
              <tr key={i}>
                <td className="p-0 m-0 align-items-center">
                  <div className="col p-0 align-items-center ">
                    <FontAwesomeIcon title="Ta bort rad" className="me-1" role="button" icon={faTrash} style={{ color: Colors.RedMedium }} onClick={() => remove(i)} />
                    {"Brytpunkt " + i}
                  </div>
                </td>
                <td className="p-0">
                  <NumberEditor
                    label=""
                    fieldName={"värmekurva." + i + "." + nameof<Värmekurva>("brytpunktUtetemp")}
                    tooltipId={nameof<MapTooltip>("VärmeSekundär_brytpunktUtetemp")}
                    formHook={formHook}
                    options={{
                      required: "Värde måste anges för brytpunkt utetemp på rad " + (i + 1),
                    }}
                  />
                </td>
                <td className="p-0">
                  <NumberEditor
                    label=""
                    fieldName={"värmekurva." + i + "." + nameof<Värmekurva>("brytpunktFramledningstemp")}
                    tooltipId={nameof<MapTooltip>("VärmeSekundär_brytpunktFramledningstemp")}
                    formHook={formHook}
                    options={{
                      required: "Värde måste anges för brytpunkt framledningstemp på rad " + (i + 1),
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card> */}
      {!isSummer && <fieldset className="form-group mt-1">
        <legend>Brytpunkter</legend>
        <div className="row">
          <div className="col-lg-2"></div>
          <div className="col-lg-5">{"Brytpunkt utetemp (°C)"}</div>
          <div className="col-lg-5">{"Brytpunkt framledningstemp (°C)"}</div>
        </div>
        {värmekurva.map((kurva: any, i: number) => (
          <div key={i} className="row">
            {i > 1 ? (
              <div className="col-lg-2">
                <FontAwesomeIcon title="Ta bort rad" className="me-1" role="button" icon={faTrash} style={{ color: Colors.RedMedium }} onClick={() => remove(i)} />
                {"Brytpunkt " + i}
              </div>
            ) : (
              <div className="col-lg-2">{"Brytpunkt " + i}</div>
            )}

            <div className="col-lg-5">
              <NumberEditor
                label=""
                fieldName={"värmekurva." + i + "." + nameof<Värmekurva>("brytpunktUtetemp")}
                tooltipId={nameof<MapTooltip>("VärmeSekundär_brytpunktUtetemp")}
                formHook={formHook}
                options={{
                  required: "Värde måste anges för brytpunkt utetemp på rad " + (i + 1),
                  min: { value: -35, message: "Värde ska vara minst -35" },
                  max: { value: 25, message: "Värde ska vara max 25" },
                }}
              />
            </div>
            <div className="col-lg-5">
              <NumberEditor
                label=""
                fieldName={"värmekurva." + i + "." + nameof<Värmekurva>("brytpunktFramledningstemp")}
                tooltipId={nameof<MapTooltip>("VärmeSekundär_brytpunktFramledningstemp")}
                formHook={formHook}
                options={{
                  required: "Värde måste anges för brytpunkt framledningstemp på rad " + (i + 1),
                  min: { value: 15, message: "Värde ska vara minst 15" },
                  max: { value: 90, message: "Värde ska vara max 90" },
                }}
              />
            </div>
          </div>
        ))}
        <div className="m-2 d-flex justify-content-end">
          <Button
            type="button"
            className="btn btn-primary"
            onClick={() =>
              append({
                brytpunktUtetemp: 0,
                brytpunktFramledningstemp: 0,
              })
            }
          >
            Lägg till brytpunkt
          </Button>
        </div>
      </fieldset>}

      {!isSummer && <div className="row ml-0">
        <div className="col-lg-12">
          <NumberEditor
            label="Parallellförkjutning  °C"
            fieldName={nameof<IModuleVattenburetSekundärsystemRound>("parallellforskjutning")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_parallellforskjutning")}
            formHook={formHook}
          />
        </div>
      </div>}
      <BFLNote formHook={formHook} />
    </>
  );
};

export default RoundVarmeSekundar;
